
const apiUrl = process.env.REACT_APP_API_URL;
export const PostGenerarCursSencerExcel = async ( json: any, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/beques/excel`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': "loop"
            },
            body: JSON.stringify(json)
        });
        if (response.ok) {
            const blob = await response.blob();
            console.log(blob);
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};